import React from 'react'
import ReactMarkdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';
import { TextStyles } from 'styles/style';

const TextContent = ({ content }) => {
  return (
    <TextStyles.Text>
      <ReactMarkdown rehypePlugins={[rehypeRaw]}>{content}</ReactMarkdown>
    </TextStyles.Text>
  )
}

export default TextContent